import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const slideIn = keyframes`
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
`

export const ModalOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      animation: ${fadeIn} 0.2s ease-in-out;
    `}
`

export const ModalContent = styled.div<{
  $width?: string
  $maxWidth?: string
  $fullScreen?: boolean
  $isOpen: boolean
}>`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  position: relative;
  width: ${({ $width }) => $width || 'auto'};
  max-width: ${({ $maxWidth }) => $maxWidth || '600px'};
  max-height: 90vh;
  overflow: auto;

  ${({ $fullScreen }) =>
    $fullScreen &&
    css`
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      border-radius: 0;
    `}

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      animation: ${slideIn} 0.3s ease-out;
    `}
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: ${({ theme }) => theme.transitions.default};
  z-index: 1;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
`
